/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InputRefreshTokenDto } from '../../models/input-refresh-token-dto';
import { OutputRefreshTokenDto } from '../../models/output-refresh-token-dto';

export interface UserManagementTokenPost$Plain$Params {
      body?: InputRefreshTokenDto
}

export function userManagementTokenPost$Plain(http: HttpClient, rootUrl: string, params?: UserManagementTokenPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OutputRefreshTokenDto>> {
  const rb = new RequestBuilder(rootUrl, userManagementTokenPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OutputRefreshTokenDto>;
    })
  );
}

userManagementTokenPost$Plain.PATH = '/UserManagement/Token';
